import { ReactNode } from 'react'
import { UserRole } from '@common/interfaces/user'
import cn from 'classnames'
import ExportsIcon from '../../assets/images/download-alt-icon.svg?react'
import ClientSettings from '../../assets/images/settings-icon2.svg?react'
import genericSs from '../../assets/styles/generic.module.scss'
import { ROUTES } from '../../constants/routes'
import Icon from '../Common/Icon'
import styles from './SideMenuClient.module.scss'

export interface IMenuData {
  label: string
  icon: ReactNode
  link: string
  key: string
  activeIcon?: ReactNode
  subItems?: ISubMenuData[]
  divider?: boolean
  category?: string
}

export interface ISubMenuData {
  label: string
  link: string
  icon: ReactNode
}

const SIDE_MENU_ADMIN: IMenuData[] = [
  {
    label: 'Clients',
    icon: <Icon name="people" size="md" />,
    link: ROUTES.HOMEPAGE,
    key: ROUTES.HOMEPAGE,
    activeIcon: <Icon name="people-active" size="md" />,
  },
  {
    label: 'Collections',
    link: ROUTES.COLLECTIONS_DASHBOARD,
    key: ROUTES.COLLECTIONS_DASHBOARD,
    icon: <Icon name="collections" size="md" />,
  },
  {
    label: 'Operations',
    icon: <Icon name="activity-box" size="md" />,
    key: ROUTES.ACTIVITY_QUEUE,
    link: ROUTES.ACTIVITY_QUEUE,
  },
  {
    label: 'Wires',
    icon: <Icon name="transfer" size="md" />,
    key: ROUTES.OUTGOING_WIRE,
    link: ROUTES.OUTGOING_WIRE,
  },
  {
    label: 'Exports',
    icon: <ExportsIcon />,
    key: ROUTES.EXPORTS_PAGE,
    link: ROUTES.EXPORTS_PAGE,
    activeIcon: <ExportsIcon className={styles.exportIcon} />,
  },
  {
    divider: true,
    label: 'CRM',
    icon: <Icon name="briefcase" size="md" />,
    key: ROUTES.CRM_HOME,
    link: ROUTES.CRM_HOME,
  },
  {
    label: 'Participants',
    icon: <Icon name="pie-chart" size="md" />,
    key: ROUTES.PARTICIPANTS_MANAGEMENT,
    link: ROUTES.PARTICIPANTS_MANAGEMENT,
    activeIcon: <Icon name="pie-chart-active" size="md" />,
  },
  {
    label: 'Prospects',
    icon: <Icon name="prospects" size="md" />,
    key: ROUTES.PROSPECTS,
    link: ROUTES.PROSPECTS,
  },
  {
    label: 'Diligence',
    icon: <Icon name="underwriting" size="md" />,
    key: ROUTES.DUE_DILIGENCE_HOME,
    link: ROUTES.DUE_DILIGENCE_HOME,
  },
  {
    divider: true,
    label: 'Users',
    icon: <Icon name="user-management" size="md" />,
    key: ROUTES.USER_MANAGEMENT,
    link: ROUTES.USER_MANAGEMENT,
    activeIcon: <Icon name="user-management-active" size="md" />,
  },
  {
    label: 'Audit Log',
    icon: <Icon name="audit-log" size="md" />,
    key: ROUTES.AUDIT,
    link: ROUTES.AUDIT,
    activeIcon: <Icon name="audit-log" size="md" />,
  },
]
export const SIDE_MENU_PORTFOLIO_USER: IMenuData[] = [
  {
    label: 'Dashboard',
    icon: <Icon name="dashboard" size="md" />,
    link: ROUTES.HOMEPAGE,
    key: ROUTES.HOMEPAGE,
  },
  {
    label: 'Collections',
    link: ROUTES.COLLECTIONS_DASHBOARD,
    key: ROUTES.COLLECTIONS_DASHBOARD,
    icon: <Icon name="collections" size="md" />,
  },
  {
    label: 'Operations',
    icon: <Icon name="activity-box" size="md" />,
    key: ROUTES.ACTIVITY_QUEUE,
    link: ROUTES.ACTIVITY_QUEUE,
  },
  {
    label: 'Wires',
    icon: <Icon name="transfer" size="md" />,
    key: ROUTES.OUTGOING_WIRE,
    link: ROUTES.OUTGOING_WIRE,
  },
  {
    label: 'Exports',
    icon: <ExportsIcon />,
    key: ROUTES.EXPORTS_PAGE,
    link: ROUTES.EXPORTS_PAGE,
    activeIcon: <ExportsIcon className={styles.exportIcon} />,
  },
  {
    divider: true,
    label: 'CRM',
    icon: <Icon name="briefcase" size="md" />,
    key: ROUTES.CRM_HOME,
    link: ROUTES.CRM_HOME,
  },
  {
    label: 'Participants',
    icon: <Icon name="pie-chart" size="md" />,
    key: ROUTES.PARTICIPANTS_MANAGEMENT,
    link: ROUTES.PARTICIPANTS_MANAGEMENT,
    activeIcon: <Icon name="pie-chart-active" size="md" />,
  },
  {
    label: 'Diligence',
    icon: <Icon name="underwriting" size="md" />,
    key: ROUTES.DUE_DILIGENCE_HOME,
    link: ROUTES.DUE_DILIGENCE_HOME,
  },
  {
    label: 'Audit Log',
    icon: <Icon name="audit-log" size="md" />,
    key: ROUTES.AUDIT,
    link: ROUTES.AUDIT,
    activeIcon: <Icon name="audit-log" size="md" />,
  },
]

export const SIDE_MENU_UW_USER: IMenuData[] = [
  {
    label: 'Dashboard',
    icon: <Icon name="dashboard" size="md" />,
    link: ROUTES.HOMEPAGE,
    key: ROUTES.HOMEPAGE,
  },
  {
    label: 'Operations',
    icon: <Icon name="activity-box" size="md" />,
    key: ROUTES.ACTIVITY_QUEUE,
    link: ROUTES.ACTIVITY_QUEUE,
  },
  {
    label: 'Collections',
    link: ROUTES.COLLECTIONS_DASHBOARD,
    key: ROUTES.COLLECTIONS_DASHBOARD,
    icon: <Icon name="collections" size="md" />,
  },
  {
    label: 'Clients',
    icon: <Icon name="people" size="md" />,
    key: ROUTES.CLIENT_MANAGEMENT,
    link: ROUTES.CLIENT_MANAGEMENT,
    activeIcon: <Icon name="people-active" size="md" />,
  },
  {
    label: 'Prospects',
    icon: <Icon name="prospects" size="md" />,
    key: ROUTES.PROSPECTS,
    link: ROUTES.PROSPECTS,
  },
  {
    label: 'CRM',
    icon: <Icon name="briefcase" size="md" />,
    key: ROUTES.CRM_HOME,
    link: ROUTES.CRM_HOME,
  },
]

export const SIDE_MENU_CLIENT_USER: IMenuData[] = [
  {
    label: 'Overview',
    icon: <Icon name="sidemenu-overview" size="sm" />,
    key: ROUTES.HOMEPAGE,
    link: ROUTES.HOMEPAGE,
    category: 'Dashboards',
  },
  {
    label: 'Activity',
    icon: <Icon name="sidemenu-activity" size="sm" />,
    link: ROUTES.ACCOUNT_ACTIVITY,
    key: ROUTES.ACCOUNT_ACTIVITY,
    category: 'Dashboards',
  },
  {
    label: 'Funding',
    icon: <Icon name="sidemenu-funding" size="sm" />,
    key: ROUTES.FUNDING,
    link: ROUTES.FUNDING,
    category: 'Dashboards',
  },
  {
    label: 'Reporting',
    icon: <Icon name="sidemenu-reporting" size="sm" />,
    key: ROUTES.SUBMIT_REPORTING,
    link: ROUTES.SUBMIT_REPORTING,
    category: 'Dashboards',
  },
  {
    label: 'Analytics',
    icon: <Icon name="sidemenu-analytics" size="sm" />,
    key: ROUTES.CLIENT_VISUALIZATIONS,
    link: ROUTES.CLIENT_VISUALIZATIONS,
    category: 'Dashboards',
  },
]

export const SIDE_MENU_DUE_DILIGENCE_CLIENT_USER: IMenuData[] = [
  {
    label: 'Overview',
    icon: <Icon name="sidemenu-overview" size="sm" />,
    key: ROUTES.HOMEPAGE,
    link: ROUTES.HOMEPAGE,
    category: 'Dashboards',
  },
  {
    label: 'Application',
    icon: <Icon name="sidemenu-funding" size="sm" />,
    key: ROUTES.APPLICATION_PAGE,
    link: ROUTES.APPLICATION_PAGE,
    category: 'Dashboards',
  },
  {
    label: 'Documents',
    icon: <Icon name="sidemenu-activity" size="sm" />,
    key: ROUTES.DOCUMENTS_PAGE,
    link: ROUTES.DOCUMENTS_PAGE,
    category: 'Dashboards',
  },
]

export const SIDE_MENU_PAST_CLIENT_USER: IMenuData[] = [
  {
    label: 'Activity',
    icon: (
      <span className={cn(genericSs.displayContents, styles.activityIcon)}>
        <Icon name="activity" size="md" />
      </span>
    ),
    link: ROUTES.HOMEPAGE,
    key: ROUTES.HOMEPAGE,
  },
  {
    label: 'Settings',
    icon: <ClientSettings />,
    key: ROUTES.SETTINGS,
    link: ROUTES.SETTINGS,
  },
]

export const SIDE_MENU_BDO_USER: IMenuData[] = [
  {
    label: 'Dashboard',
    icon: <Icon name="dashboard" size="md" />,
    key: ROUTES.HOMEPAGE,
    link: ROUTES.HOMEPAGE,
  },
]

export const SIDE_MENU_PARTICIPANTS_USER: IMenuData[] = [
  {
    label: 'Clients',
    icon: <Icon name="people" size="md" />,
    link: ROUTES.HOMEPAGE,
    key: ROUTES.HOMEPAGE,
    activeIcon: <Icon name="people-active" size="md" />,
  },
  {
    label: 'Wires',
    icon: <Icon name="transfer" size="md" />,
    key: ROUTES.OUTGOING_WIRE,
    link: ROUTES.OUTGOING_WIRE,
  },
]

const SIDE_MENU: Record<UserRole, IMenuData[]> = {
  [UserRole.ADMIN]: SIDE_MENU_ADMIN,
  [UserRole.PORTFOLIO_ADMIN]: SIDE_MENU_PORTFOLIO_USER,
  [UserRole.PORTFOLIO_USER]: SIDE_MENU_PORTFOLIO_USER,
  [UserRole.UW_USER]: SIDE_MENU_UW_USER,
  [UserRole.CLIENT_USER]: [],
  [UserRole.BDO]: SIDE_MENU_BDO_USER,
  [UserRole.PARTICIPANT_USER]: SIDE_MENU_PARTICIPANTS_USER,
  [UserRole.BOT_USER]: [],
  // These are the client *portal's* menus, which only a CLIENT_USER ever sees
  // (MainLayout picks this rail on role alone) — the tasks-and-messaging role has its
  // own single-item rail in SideMenu/SideMenuConfig.
  [UserRole.TASKS_AND_MESSAGING]: [],
} as const

export { SIDE_MENU }
